import { DateInput, Select, SelectItem } from '@heroui/react'
import { getLocalTimeZone, today } from '@internationalized/date'
import PathwaySelect from 'components/Hero/PathwaySelect'
import PhoneInput from 'components/Hero/PhoneInput'
import { KVInput, TagsSelect } from '../inputs'

/*
 * Call-logs specific select inputs
 */
function DirectionSelect({ value, ...props }) {
  return (
    <Select aria-label="Direction" selectedKeys={[value]} {...props}>
      { }
      <SelectItem key={true}>Inbound</SelectItem>
      <SelectItem key={false}>Outbound</SelectItem>
    </Select>
  )
}

function StatusSelect({ value, ...props }) {
  return (
    <Select aria-label="Status" selectedKeys={[value]} {...props}>
      <SelectItem key="completed">Completed</SelectItem>
      <SelectItem key="failed">Failed</SelectItem>
      <SelectItem key="no-answer">No Answer</SelectItem>
      <SelectItem key="busy">Busy</SelectItem>
      <SelectItem key="canceled">Canceled</SelectItem>
      <SelectItem key={null}>Unknown</SelectItem>
    </Select>
  )
}

function AnsweredBySelect({ value, ...props }) {
  return (
    <Select
      aria-label="Answered by"
      endContent={(
        <span className="text-tiny text-nowrap text-default-400">
          for calls with
          {' '}
          <code>answer_by_enabled</code>
          {' '}
          on
        </span>
      )}
      selectedKeys={[value]}
      {...props}
    >
      <SelectItem key="voicemail">Voicemail</SelectItem>
      <SelectItem key="human">Human</SelectItem>
      <SelectItem key="no-answer">No answer</SelectItem>
      <SelectItem key="unknown">Unknown</SelectItem>
    </Select>
  )
}

export const callFilterableFields = {
  inbound: { label: 'Direction', operators: ['equals'], inputComponent: DirectionSelect },
  c_id: { label: 'Call ID', operators: ['equals', 'not'] },
  to: { label: 'To', operators: ['equals', 'not'], inputComponent: PhoneInput },
  from: { label: 'From', operators: ['equals', 'not'], inputComponent: PhoneInput },
  call_length: { label: 'Duration', operators: ['equals', 'gt', 'lt', 'gte', 'lte'], inputProps: { endContent: 'minutes', type: 'number' } },
  created_at: { label: 'Created', operators: ['equals', 'gt', 'lt', 'gte', 'lte'], inputComponent: DateInput, inputProps: { defaultValue: today(getLocalTimeZone()) } },
  status: { label: 'Status', operators: ['equals', 'not'], inputComponent: StatusSelect },
  pathway_id: { label: 'Pathway', operators: ['equals', 'not'], inputComponent: PathwaySelect },
  batch_id: { label: 'Batch ID', operators: ['equals', 'not'] },
  call_notes: { label: 'Notes', operators: ['contains', 'isNotEmpty', 'isEmpty'] },
  pathway_tags: { label: 'Tags', operators: ['hasSome', 'none'], inputComponent: TagsSelect },
  analysis: { label: 'Analysis', operators: ['hasSome', 'none'], inputComponent: KVInput },
  variables: { label: 'Variables', operators: ['hasSome', 'none'], inputComponent: KVInput },
  price: {
    label: 'Price',
    operators: ['equals', 'gt', 'lt', 'gte', 'lte'],
    inputProps: {
      startContent: (
        <div className="pointer-events-none flex items-center">
          <span className="text-small text-default-400">$</span>
        </div>
      ),
      type: 'number',
      placeholder: '0.00',
    },
  },
  answered_by: { label: 'Answered by', operators: ['equals', 'not'], inputComponent: AnsweredBySelect },
}
